import React from "react";
import { shape, string, bool, object } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { ContentTextSection } from "./ContentTextSection";

const ContentTextSectionConnector = ({ data }) => (
	<ContentTextSection
		text={data.content.childMarkdownRemark.html}
		collapse={data.collapseToggle}
		embeddedContent={data?.embeddedContent}
	/>
);

ContentTextSectionConnector.propTypes = {
	data: shape({
		content: shape({
			childMarkdownRemark: shape({
				html: string,
			}),
		}),
		embeddedContent: object,
		collapseToggle: bool,
	}),
};
ContentTextSectionConnector.defaultProps = {
	data: null,
};

export default ContentTextSectionConnector;
export { ContentTextSectionConnector };
